interface PaginationProps {
  current: number;
  total: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ current, total, onPageChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  const maxVisible = 7;

  if (total <= maxVisible) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    pages.push(1);
    let start = Math.max(2, current - 1);
    let end = Math.min(total - 1, current + 1);

    if (current <= 3) {
      end = Math.min(5, total - 1);
    }
    if (current >= total - 2) {
      start = Math.max(total - 4, 2);
    }

    if (start > 2) pages.push(-1);
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push(-2);
    pages.push(total);
  }

  return (
    <div className="flex items-center justify-center gap-1 flex-wrap">
      <button
        onClick={() => onPageChange(current - 1)}
        disabled={current <= 1}
        className="w-9 h-9 flex items-center justify-center rounded-lg text-sm border border-background-200 text-foreground-600 hover:bg-background-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((p, i) => {
        if (p < 0) {
          return (
            <span key={p} className="w-9 h-9 flex items-center justify-center text-sm text-foreground-400">
              ...
            </span>
          );
        }
        return (
          <button
            key={i}
            onClick={() => onPageChange(p)}
            className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              p === current
                ? 'bg-primary-500 text-white'
                : 'border border-background-200 text-foreground-600 hover:bg-background-100'
            }`}
          >
            {p}
          </button>
        );
      })}
      <button
        onClick={() => onPageChange(current + 1)}
        disabled={current >= total}
        className="w-9 h-9 flex items-center justify-center rounded-lg text-sm border border-background-200 text-foreground-600 hover:bg-background-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}